var map = {
	"./caveat/caveat-700-normal.woff2": 4880,
	"./nunito-sans/nunito-sans-400-italic.woff2": 870,
	"./nunito-sans/nunito-sans-400-normal.woff2": 2639,
	"./nunito-sans/nunito-sans-700-italic.woff2": 5299,
	"./nunito-sans/nunito-sans-700-normal.woff2": 5394,
	"./nunito-sans/nunito-sans-800-normal.woff2": 7003,
	"./nunito-sans/nunito-sans-900-normal.woff2": 1600,
	"./nunito/nunito-800-normal.woff2": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5067;